import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ClaimReservationState } from './types'
import { DataFetchingState } from '@AppState/types'
import { PlayerDataServiceAPI } from '@API/data-services/player-data-service'

export const claimReservationInitialState: ClaimReservationState = {
  fetchState: DataFetchingState.IDLE,
  claimReservation: null,
}

export const fetchClaimReservation = createAsyncThunk('fetchReservation', async (id: string) => {
  return await PlayerDataServiceAPI.getAppointmentById(id)
})

export const claimReservationSlice = createSlice({
  name: 'claim-reservation',
  initialState: claimReservationInitialState,
  reducers: {
    clearSavedReservation(state) {
      const url = new URL(window.location.href)
      url.searchParams.delete('claim-id')
      window.history.replaceState({}, '', url.toString())
      state.fetchState = DataFetchingState.IDLE
      state.claimReservation = null
    },
    setClaimReservation(state, action) {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.claimReservation = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClaimReservation.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.claimReservation = action.payload
    })
    builder.addCase(fetchClaimReservation.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
      state.claimReservation = null
    })
    builder.addCase(fetchClaimReservation.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
      state.claimReservation = null
    })
  },
})

export const ClaimReservationActions = {
  ...claimReservationSlice.actions,
}

export const ClaimReservationReducer = claimReservationSlice.reducer
